export class EnvUtil {
  public static isDev() {
    return process.env.VUE_APP_ENV === 'dev'
  }

  public static isProd() {
    return process.env.VUE_APP_ENV === 'prod'
  }

  public static isStaging() {
    return process.env.VUE_APP_ENV === 'staging'
  }

  public static isAPP(name: string) {
    return process.env.VUE_APP_NAME && process.env.VUE_APP_NAME.toLowerCase().includes(name)
  }

  public static isISC() {
    return this.isAPP('isc')
  }

  public static isSaas() {
    return this.isAPP('shs')
  }

  public static isApph5() {
    return this.isAPP('apph5')
  }

  public static isCampus() {
    return this.isAPP('campus')
  }

  public static isAgency() {
    return this.isAPP('agency')
  }

  public static isOperation() {
    return this.isAPP('operation')
  }

  public static isJumpStar() {
    return this.isAPP('jumpstar')
  }

  public static appName() {
    return process.env.VUE_APP_NAME || ''
  }

  public static appNameZHCN() {
    return process.env.VUE_APP_NAME_ZHCN || ''
  }

  public static appNameDesc() {
    return process.env.VUE_APP_NAME_DESC || ''
  }

  public static buildLogFileName() {
    return `kd${this.appName()}`
  }
}
